import { Injectable, EventEmitter } from '@angular/core';

import { ConfigurationService } from '../shared/configuration.service';
import { Headers, Http, Response, RequestOptions } from '@angular/http';
import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

@Injectable()
export class SettingsService {

  constructor(private http: Http,
    private _configuration: ConfigurationService


  ) {

  }

  private emitChangeSource = new Subject<boolean>();

  private emitBackgroundChanged = new Subject<string>();
  changeEmitted$ = this.emitChangeSource.asObservable();

  //changeEmitted = this.emitBackgroundChanged.asObservable();
  emitIsLiveChanged(isLive: boolean) {

    this.emitChangeSource.next(isLive);
  }


 emitHeaderUpdated(imageUrl:string) {

    this.emitBackgroundChanged.next(imageUrl);
  }
  UpdateRegistryLiveStatus(isLive: boolean): Observable<any> {

    return this.http
    .post(this._configuration.baseUrl + '/api/account/update-registry-livestatus?isLive=' + isLive, null, this.requestOptions())
      .map(response => {
        this.emitIsLiveChanged(isLive);
        return response.json();
      })
      .catch(this.handleError);

  }




  private requestOptions(): RequestOptions {
    let headers = new Headers({ 'Content-Type': 'application/json' }); // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers, withCredentials: true });
    return options;
  }

  GetAlerts(): Observable<any> {

    return this.http.get(this._configuration.baseUrl + '/api/settings/alerts', this.requestOptions())
      .map((response: any) => {
       return response.json();
      })
      .catch(this.handleError);
  }


  DismissAlerts(): Observable<any> {

    return this.http.post(this._configuration.baseUrl + '/api/settings/dismiss-alerts', null, this.requestOptions())
      .map((response: any) => {
        return response;
      })
      .catch(this.handleError);

  }





  GetPersonalSettings(): Observable<any> {

    return this.http.get(this._configuration.baseUrl + '/api/settings/personal', this.requestOptions())
      .map((response: any) => {
          return response.json();
      })
      .catch(this.handleError);
  }

  GetPaymentSettings(): Observable<any> {
    //let data: any | null = this._cacheService.get('settings-payments');
    // if (data != null) {
    //   return Observable.of(data);
    // }
    return this.http.get(this._configuration.baseUrl + '/api/settings/payments', this.requestOptions())
      .map((response: any) => {
     //   this._cacheService.set('settings-payments', JSON.parse(response._body), { expires: Date.now() + 1000 * 60 * 5 });
        return response.json();
      })
      .catch(this.handleError);
  }
  SavePersonalSettings(formBody: string): Observable<any> {
    return this.http.post(this._configuration.baseUrl + '/api/settings/personal', formBody, this.requestOptions())
      .map(response => { return response; })
      .catch(this.handleError);

  }

//api/settings/registry-name-available






  GetIfRegistryIsAvailable(name:string): Observable<any> {

    return this.http.get(this._configuration.baseUrl + '/api/settings/registry-name-available?registryName='+name, this.requestOptions())
      .map((response: any) => {

        return response.json();
      })
      .catch(this.handleError);
  }



  SaveNotificationSettings(formBody: string): Observable<any> {

    return this.http.post(this._configuration.baseUrl + '/api/settings/notifications', formBody, this.requestOptions())
      .map(response => { return response; })
      .catch(this.handleError);

  }

  SaveFeeSettings(formBody: string): Observable<any> {

    return this.http.post(this._configuration.baseUrl + '/api/settings/fees', formBody, this.requestOptions())
      .map(response => { return response; })
      .catch(this.handleError);

  }


  GetSecuritySettings(): Observable<any> {
    return this.http.get(this._configuration.baseUrl + '/api/settings/security', this.requestOptions())
      .map((res) => { return res.json(); })
      .catch(this.handleError);
  }

  GetNotificationSettings(): Observable<any> {
      return this.http.get(this._configuration.baseUrl + '/api/settings/notifications', this.requestOptions())
      .map((response: any) => {
       // this._cacheService.set('settings-notifications', JSON.parse(response._body), { expires: Date.now() + 1000 * 60 * 5 });
        return response.json();
      })
      .catch(this.handleError);
  }



  GetFeeSettings(): Observable<any> {

    return this.http.get(this._configuration.baseUrl + '/api/settings/fees', this.requestOptions())
      .map((response: any) => {
      //  this._cacheService.set('settings-fees', JSON.parse(response._body), { expires: Date.now() + 1000 * 60 * 5 });
        return response.json();
      })
      .catch(this.handleError);
  }


  private extractData(res: Response) {

    let body = res.json();
    return body || {};
  }


  private handleError(error: Response | any) {
    // In a real world app, we might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `$ {error.status} - $ {error.statusText || ''}$ {err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }

    return Observable.throw(errMsg);
  }
}







// WEBPACK FOOTER //
// ./src/app/settings/settings.service.ts